// extracted by mini-css-extract-plugin
module.exports = {"container":"loading-indicator_container__xIlTN","indicator":"loading-indicator_indicator__bxJOV","indicatorSecondary":"loading-indicator_indicatorSecondary__1nlZY"};